module.exports = __webpack_public_path__ + "static/laptop.02556653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laptop.png
// module id = 548
// module chunks = 35783957827783